export default __webpack_public_path__ + "static/media/newhome-medico.cb4d26dc.png";